import { createApp } from 'vue';
import VueDraggableResizable from 'vue3-draggable-resizable';
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css';
import PerfectScrollbar from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';
import router from '@/router/index';
import { key, store } from '@/store';
import App from './App.vue';
import '@/style/basic.less';
import { createPinia } from 'pinia'
import { useHostConfigStore } from '@/store/hostConfigStore'; 
const pinia = createPinia()


function initializeHostConfig() {
    const domain = window.location.hostname;
    const protocol = window.location.protocol.replace(":", ""); // "http" or "https"
    const protocol_ws = protocol === 'https' ? 'wss' : 'ws'
    const port = window.location.port || (protocol === 'https' ? '443' : '80');
    const hostConfigStore = useHostConfigStore();
    console.log(window.location);    
    hostConfigStore.setConfig({
        host_domain: domain,
        host_protocol: protocol,
        host_port: port,
        host_protocol_ws: protocol_ws,
        origin:window.location.origin
    });
    // hostConfigStore.setConfig({
    //     host_domain: "playback.zelostech.sg",
    //     host_protocol: "https",
    //     host_port: 80,
    //     host_protocol_ws: 'wss',
    //     origin:'https://playback.zelostech.sg'
    // });
}


const app = createApp(App);
app.use(PerfectScrollbar);
app.use(VueDraggableResizable);
app.use(pinia);
initializeHostConfig();  // 启动前配置 API 域名
app.use(router).use(store, key).mount('#app');



